const messages = {
    cannotReassignUnassignedLead: 'El lead debe estar asignado antes de poder reasignarlo',
    documentsTypes: 'Tipos de Documentos',
    documentType: 'Tipo de Documento',
    consents: 'Consentimientos',
    completed: 'Completado',
    markCompleted: 'Marcar completado',
    consentMarkedCompleted: 'Consentimiento marcado como completado',
    consentMarkedPending: 'Consentimiento marcado como pendiente',
    isRequired: 'Es Requerido',
    signatureRequired: 'Firma Requerida',
    generalAnesthesia: 'Anestesia General',
    documentLanguage: 'Idioma del Documento',
    addDocumentType: 'Adicionar Tipo de Documento',
    editDocumentType: 'Editar Tipo de Documento',
    addConsent: 'Adicionar Consentimiento',
    editConsent: 'Editar Consentimiento',
    addPaymentMethod: 'Adicionar método de pago',
    editPaymentMethod: 'Editar método de pago',
    height: 'Altura',
    weight: 'Peso',
    drugs: 'Drogas',
    alcohol: 'Alcohol',
    nicotine: 'Nicotina',
    medicalAilments: 'Dolencias Médicas',
    medicines: 'Medicamentos',
    otherMedicalConditions: 'Otras Condiciones Médicas',
    addYourComment: 'Adicione su Comentario',
    viewMore: 'Ver Más',
    addedAComment: 'Adicionó un Comentario',
    addedTags: 'etiquetas añadidas',
    viewDetailsFor: 'Ver Detalles Para',
    medicalRecord: 'Historial Médico',
    surgicalHistory: 'Antecedentes Quirúrgicos',
    imageType: 'Tipo de Imagen',
    before: 'Después',
    after: 'Antes',
    consentEditedSuccesfully: 'Consentimiento editado satisfactoriamente',
    editProfile: 'Editar Perfil',
    size: 'Longitud',
    pountAbbreviation: 'Lbs',
    bmi: 'IMC',
    sendForSignature: 'Enviar para firma',
    signNowInviteSelectConsents: 'Seleccione consentimientos existentes para enviar a firma.',
    signNowInviteSent: 'Invitacion de SignNow enviada',
    signNowNotLinked: 'SignNow no vinculado',
    signNowInviteConfirmTitle: 'Confirmar correo del lead',
    signNowInviteConfirmText:
        'Confirme que el correo del lead sea correcto antes de enviar la invitacion de SignNow: {email}',
    signNowInviteConfirmAction: 'Enviar invitacion',
    signNowInviteConfirmDescription:
        'Confirme el correo del lead antes de enviar la invitacion de SignNow: {email}',
    signNowInviteEmailLabel: 'Correo del lead',
    signNowInviteEmailRequired: 'El correo del lead es obligatorio.',
    signNowInviteEmailInvalid: 'Ingrese un correo electronico valido.',
    signNowInviteEmailHint:
        'Los cambios actualizan el lead antes de enviar la invitacion de SignNow.',
    leadEmailUnknown: 'Correo desconocido',
    noSignNowTemplatesAvailable:
        'No hay consentimientos vinculados a SignNow disponibles. Vincule una plantilla para enviar a firma.',
    signNowTemplatesOnly: 'Solo los consentimientos vinculados a SignNow se pueden enviar a firma.',
    deprecadedHeight:
        'Altura no usada: Se conserva solo con fines de referencia, para configurar el nuevo campo de altura.',
    newFeaturesWarning:
        'Hemos hecho mejoras importantes. Actualiza para obtener las últimas funciones y correcciones.',
    printConsents: 'Imprimir consentimientos',
    printConsentsSelectDocuments:
        'Seleccione documentos de consentimiento completados para descargar como PDF combinado.',
    noPrintableConsentDocuments:
        'No hay documentos de consentimiento completados disponibles para imprimir.',
    printConsentsPdfReady: 'PDF combinado descargado exitosamente.',
    printConsentsPdfError:
        'Error al generar el PDF de consentimientos. Por favor, intente de nuevo.',
    category: 'Categoria',
    categories: 'Categorias',
    none: 'Ninguna',
    consentTemplateCategories: 'Administre las categorias de plantillas de consentimiento.',
    addCategory: 'Adicionar categoria',
    editCategory: 'Editar categoria',
    confirmDeleteCategory: 'Confirmar eliminacion de categoria',
    deleteCategory: 'Esta seguro de que desea eliminar esta categoria?',
    signNowStatus: 'Estado de SignNow',
    uncategorized: 'Sin categoria',
    signNowRoleAssignmentTitle: 'Asignar firmantes',
    signNowRoleAssignmentDescription:
        'Asigne un correo electronico a cada rol de firmante. Los roles obligatorios deben tener un correo valido.',
    signNowRolePatientBadge: 'Paciente',
    signNowRoleSigningOrder: 'Orden: {order}',
    signNowRoleEmailPlaceholder: "firmante{'@'}ejemplo.com",
    signNowRoleEmailRequired: 'El correo es obligatorio para este rol.',
    signNowFetchingRoles: 'Cargando roles de firmantes...',
    signNowRoleFetchError: 'Error al cargar los roles de firmantes. Intente de nuevo.',
    signNowRoleAssignmentUnavailable:
        'Los roles de firmantes no estan disponibles para los documentos seleccionados. Cierre este paso e intente de nuevo.',
    signNowRoleDuplicateEmailWarning:
        'Algunos roles comparten el mismo correo. SignNow enviara una sola invitacion por paso a ese correo compartido.',
    required: 'Obligatorio',
    optional: 'Opcional',
    requireDescriptionForAdditionalDocuments: 'Requerir descripcion para documentos adicionales',
    envelopeTrackingTitle: 'Seguimiento de Sobres',
    envelopeTrackingDescription:
        'Revise los sobres enviados, la cobertura de consentimientos y el estado de finalización.',
};

export default messages;
